import Vue from 'vue'
import VueI18n from 'vue-i18n'
import commonEcMessage from './i18n/commonEc.json'
import ecsiteMessage from './i18n/ecsite.json'
import suiseiMessage from './i18n/suisei.json'
import dieselMessage from './i18n/diesel.json'
import demoMessage from './i18n/demo.json'
import demo2Message from './i18n/demo2.json'
import demo3Message from './i18n/demo3.json'
import demo4Message from './i18n/demo4.json'
import cjdemoMessage from './i18n/cjdemo.json'
import hcjMessage from './i18n/hcj.json'
import moisteaneMessage from './i18n/moisteane.json'
import miyabiMessage from './i18n/miyabi.json'
import njoyMessage from './i18n/njoy.json'
import albionMessage from './i18n/albion.json'
import chukyoMessage from './i18n/chukyo.json'
import supportMessage from './i18n/support.json'
import nsrnMessage from './i18n/nsrn.json'
import baeltzMessage from './i18n/baeltz.json'
import nagasakaMessage from './i18n/nagasaka.json'
import nagasaka1183Message from './i18n/nagasaka1183.json'
import mpd150Message from './i18n/mpd150.json'
import ntsbMessage from './i18n/ntsb.json'
import umeMessage from './i18n/umeasobi.json'
import takanashiEcMessage from './i18n/takanashiEc.json'
import takanashiProMessage from './i18n/takanashiPro.json'
import takanashiShahanMessage from './i18n/takanashiShahan.json'
import shop from './i18n/shop.json'
import business from './i18n/business.json'
import shahan from './i18n/shahan.json'
import gourmetMessage from './i18n/gourmet.json'
import yutaiMessage from './i18n/yutai.json'
import wadacalMessage from './i18n/wadacal.json'
import vdrugMessage from './i18n/vdrug.json'
import chigusaMessage from './i18n/chigusa.json'
import chefmarcheMessage from './i18n/chefmarche.json'
import meguroMessage from './i18n/meguro.json'
import suyaMessage from './i18n/suya.json'
import catalogMessage from './i18n/catalog.json'
import saiwaiMessage from './i18n/saiwai.json'
import auraMessage from './i18n/aura.json'
import kojinMessage from './i18n/kojin.json'
import hojinMessage from './i18n/hojin.json'
import giftsMessage from './i18n/gifts.json'
import tkorderMessage from './i18n/tkorder.json'
import premiumMessage from './i18n/premium.json'
import gcomfort from './i18n/gcomfort.json'
import masukiMessage from './i18n/masuki.json'
import otaMessage from './i18n/ota.json'
import aichiMessage from'./i18n/a-aichidenki.json'
import suminoeMessage from'./i18n/b-suminoe.json'
import halmekMessage from'./i18n/halmek.json'


Vue.use(VueI18n)

const messages = {
  commonEc:commonEcMessage,
  ecsite: ecsiteMessage,
  suisei: suiseiMessage,
  diesel: dieselMessage,
  demo: demoMessage,
  demo2: demo2Message,
  demo3: demo3Message,
  demo4: demo4Message,
  cjdemo: cjdemoMessage,
  hcj: hcjMessage,
  moisteane: moisteaneMessage,
  miyabi:miyabiMessage,
  njoy: njoyMessage,
  albion: albionMessage,
  chukyo: chukyoMessage,
  support: supportMessage,
  nsrn : nsrnMessage,
  baeltz : baeltzMessage,
  nagasaka : nagasakaMessage,
  nagasaka1183: nagasaka1183Message,
  jue1m: mpd150Message,
  ntsb: ntsbMessage,
  umeasobi : umeMessage,
  takanashiEc : takanashiEcMessage,
  takanashiPro : takanashiProMessage,
  takanashiShahan : takanashiShahanMessage,
  shop : shop,
  business : business,
  shahan : shahan,
  gourmet : gourmetMessage,
  yutai : yutaiMessage,
  wadacal : wadacalMessage,
  vdrug : vdrugMessage,
  28 : chigusaMessage,
  chefmarche : chefmarcheMessage,
  meguro : meguroMessage,
  onlineshop : suyaMessage,
  catalog : catalogMessage,
  saiwai: saiwaiMessage,
  Aura: auraMessage,
  kojin: kojinMessage,
  hojin: hojinMessage,
  gifts: giftsMessage,
  tkorder: tkorderMessage,
  premium: premiumMessage,
  2025 : gcomfort,
  masuki: masukiMessage,
  ota : otaMessage,
  'a-aichidenki' : aichiMessage,
  'b-suminoe' : suminoeMessage,
  halmek : halmekMessage
}

const i18n = new VueI18n({
  locale: 'commonEc', // set locale
  messages: messages,
  fallbackLocale: 'commonEc',
  silentTranslationWarn: true
})

export default i18n